// src/chatbot/components/MessageTimestamp.tsx
import React from "react";
import { useTranslation } from "react-i18next";
import { FaClock } from "react-icons/fa";
import type { Branch } from "~/types/new_types";

interface MessageTimestampProps {
  timestamp: Date;
  isUser: boolean;
  theme: Branch["theme"];
}

const MessageTimestamp: React.FC<MessageTimestampProps> = ({
  timestamp,
  isUser,
  theme,
}) => {
  const { i18n } = useTranslation();

  const formatTime = (date: Date) => {
    return new Intl.DateTimeFormat(i18n.language, {
      hour: "2-digit",
      minute: "2-digit",
    }).format(date);
  };

  return (
    <div
      className={`flex items-center gap-1 mt-2 text-xs ${
        isUser ? "justify-end" : "justify-start"
      }`}
      style={{ color: `${theme.textColor}60` }}
    >
      <FaClock size={10} />
      <span>{formatTime(timestamp)}</span>
    </div>
  );
};

export default MessageTimestamp;
